import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { arrowUpRight } from '@ibk/shared-assets';
import { useTranslation } from '@ibk/shared-translation';
import { handleInvoiceVisualization, InvoiceStatus } from '../../../../utils/invoiceUtils';
import styles from './InvoiceButton.module.css';
export const InvoiceButton = ({ status, invoices, onShowAlert, className = '' }) => {
    const { t } = useTranslation();
    const handleViewInvoices = () => {
        if (status === InvoiceStatus.AVAILABLE) {
            handleInvoiceVisualization(invoices);
        }
        else {
            onShowAlert?.();
        }
    };
    return (_jsxs("div", { className: `${styles.container} ${className}`, children: [_jsx("span", { className: styles.invoiceText, "data-testid": 'textInvoiceMain', children: t('benefits.recharge-details.invoice.button') }), _jsxs("button", { className: styles.viewLink, "data-testid": 'buttonInvoiceView', onClick: handleViewInvoices, disabled: false, type: 'button', children: [t('benefits.recharge-details.invoice.view'), _jsx("img", { src: arrowUpRight, alt: 'arrow', className: styles.arrowIcon })] })] }));
};
export default InvoiceButton;
